const PUBLIC_API_URL = window.PUBLIC_API_URL;
const HIDE_APPD = window.HIDE_APPDATE;
const TITLE = window.DOCUMENT_TITLE;
const DESCR = window.META_DESCRIPTION;
const ROBOTS = window.META_ROBOTS;
const APP_THEME = window.THEME;
const APP_SHOW_REVIEWS = window.SHOW_REVIEWS;
const RESTRICT_ORDERING = window.TABLE_QR_ORDERING_ONLY;
const SIMPLE_QR_VAR = window.QR_READ_ONLY;
const VIVA_SMART_VAR = window.VIVA_SMART;
const VIVA_SOURCE_VAR = window.VIVA_SOURCE;
const SITE_ID_VAR = window.SITE_ID;
const STRIPE_KEY_VAR = window.STRIPE_PUBLISHABLE_KEY;

export const API_URL = PUBLIC_API_URL;
//HIDE_QR removed 2026-08-21: the app-download section is now gated by settings.showMobileQR
//(feathersStore.showAppDownload()), the same flag the dashboard uses for its mobile-QR button,
//so a shop is switched on from the dashboard instead of by editing constants.js and republishing.
//window.HIDE_QR_CODES is still present in every deployed constants.js and is simply ignored.
export const HIDE_APPDATE = HIDE_APPD;
export const DOCUMENT_TITLE = TITLE;
export const META_DESCRIPTION = DESCR;
export const META_ROBOTS = ROBOTS;
export const THEME = APP_THEME;
export const SHOW_REVIEWS = APP_SHOW_REVIEWS;
export const TABLE_QR_ORDERING_ONLY = RESTRICT_ORDERING;
export const QR_READ_ONLY = SIMPLE_QR_VAR;
export const VIVA_SMART = VIVA_SMART_VAR;
export const VIVA_SOURCE = VIVA_SOURCE_VAR || ""; // empty => server falls back to legacy VIVA_SMART_SOURCECODE
export const SITE_ID = SITE_ID_VAR || ""; // connected-eshop id; empty => legacy eshop-boolean visibility + legacy Viva source (server fallback)
export const STRIPE_PUBLISHABLE_KEY = STRIPE_KEY_VAR;

//export const SANDBOX_CLIENT_ID = "Ab9xBziZRnJjCwgOIgQb-uTWsr6cWG1B5nCVup5m2EcrZib1dD7V70LViTk6rL3ZvPH0Sg3IAFQDBLFZ"
//export const PRODUCTION_CLIENT_ID = "Aan6sxIsCGqkQgK57MaPULPsAmfwmuIxAQOEiM7qN1zD32LHzayz4PtlC4Z2AD0AMsdZBYS38rGdq6-x"
//export const GOOGLE_CLIENT_ID = "597039682294-a9dbtm4j2u43o5io54kb3rnleg57vk87.apps.googleusercontent.com"
//export const FACEBOOK_APP_ID = "443563063396175"
//export const NBG_PUBLIC_KEY = "lvpb_NzM1OWUxNjAtZjM3Ni00OTg0LWIwMjEtYTA3ZGUwZWEzODkw"
//export const TABLE_QRCODE_PSW = "Hv63sbUg"

export const ADMIN_ID = '5e1748e37073e110a0daa4c1';
export const DEFAULT_EMAIL = "defaultUser@gmail.com";
export const DEFAULT_PSW = ")j~nKj/,N}N6,8&cVVV#G!=F*y";
// This is a regex LITERAL, so it must carry regex escapes, not string escapes. It used to be
// written with doubled backslashes (\\+, [ \\-]), which inside a literal means "a literal
// BACKSLASH followed by +" and the class {space, backslash, hyphen} — so the international-prefix
// and parenthesised branches could never match: "+447911123456", "+44 7911 123456",
// "(020) 7946 0958" and even "+306912345678" all failed. Only the plain-digits branch worked,
// which is why Greece never noticed. Bench-verified after the fix: every string the old literal
// accepted still passes (6912345678, 2114115591, 210 4115591, 020 7946 0958, 07911123456...),
// the four shapes above now pass, and junk ("abc", "1", "++44", "") still fails.
//
// Country-code branch widened `[1-9]{1,4}` -> `[1-9][0-9]{0,3}`: the old class rejected a ZERO
// anywhere in the dialling code, so "+30 210 4115591" failed while "+306912345678" passed - the
// separator forced the code to be matched by this branch alone. That hit GREECE (+30) as hard as
// the UK (+40, +420...). A country code cannot START with 0, hence [1-9] for the first digit only.
// This is a strict SUPERSET of the old class - every string the old one matched still matches -
// so no tenant loses a phone number that works today.
//
// This literal is now the GREEK/legacy shape. Non-Greek tenants are validated by
// feathersStore.phoneIsValid(), which branches on settings.country - see there.
export const PHONE_REGEX =/^((\+[1-9][0-9]{0,3}[- ]*)|(\([0-9]{2,3}\)[- ]*)|([0-9]{2,4})[- ]*)*?[0-9]{3,4}?[- ]*[0-9]{3,4}?$/ ;